import React from "react";

const OPTIONS = [
  { value: "", label: "All", title: "Show all numbers" },
  {
    value: "converted",
    label: "Converted",
    title: "SIMs converted to TT OTP",
    activeBg: "#6c757d",
  },
  {
    value: "requested",
    label: "Requested",
    title: "Conversion already requested",
    activeBg: "#fd7e14",
  },
  {
    value: "not_converted",
    label: "Gateway SIM",
    title: "Gateway SIMs not yet converted",
    activeBg: "#0d6efd",
  },
];

const NEW_TT_EMAIL_OPTION = {
  value: "new_tt_email",
  label: "New TT Account",
  title: "Pending Get New TM Account requests",
  activeBg: "#0d6efd",
};

const PILL = {
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: 1.2,
  padding: "0.35rem 0.7rem",
  borderRadius: "999px",
  border: "1px solid #dee2e6",
  background: "#fff",
  color: "#495057",
};

/**
 * Conversion status chips (not a dropdown).
 * Empty value = all numbers.
 */
export default function ConversionStatusFilter({
  value = "",
  onChange,
  showNewTtEmail = false,
}) {
  const current = value || "";
  const options = showNewTtEmail
    ? [OPTIONS[0], NEW_TT_EMAIL_OPTION, ...OPTIONS.slice(1)]
    : OPTIONS;

  return (
    <div
      className="d-flex flex-wrap align-items-center gap-1"
      role="group"
      aria-label="Filter by conversion status"
    >
      {options.map((opt) => {
        const active = current === opt.value;
        return (
          <button
            key={opt.value || "all"}
            type="button"
            title={opt.title}
            aria-pressed={active}
            onClick={() => {
              if (opt.value && active) onChange?.("");
              else onChange?.(opt.value);
            }}
            style={{
              ...PILL,
              ...(active
                ? {
                    background: opt.activeBg || "#212529",
                    borderColor: opt.activeBg || "#212529",
                    color: "#fff",
                  }
                : null),
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
